export interface UserColor {
  userId: number;
  userName: string;
  color: string;
}

export interface UserColorInputs {
  userId?: number;
  color?: string;
}

export const UserColors = [
  { value: '476ec9', name: 'Blue' },
  { value: '0000ff', name: 'Blue 2' },
  { value: '00b4ff', name: 'Blue light' },
  { value: '000099', name: 'Blue dark' },
  { value: 'ff0000', name: 'Red' },
  { value: 'e6272a', name: 'Red dark' },
  { value: 'ff5c33', name: 'Red light' },
  { value: '32a852', name: 'Green' },
  { value: '00c800', name: 'Green 2' },
  { value: '00ff00', name: 'Green lime' },
  { value: '339633', name: 'Green dark' },
  { value: 'e3d00b', name: 'Yellow' },
  { value: 'f08a41', name: 'Orange' },
  { value: 'a444c9', name: 'Purple' },
  { value: '996633', name: 'Brown' },
  { value: '4d4d4d', name: 'Grey' },
  { value: '00e6e6', name: 'Aqua' },
];

export const getUserColorClass = (userColors: UserColor[], userId: number) => {
  if (!userColors) return '';
  const colors = userColors.filter((x) => x.userId === userId);
  if (!colors || colors.length === 0) return '';
  return `col_${colors[0].color.replace('#', '')}`;
};

export const getColorClass = (value: string) => {
  return `col_${value}`;
};
